import { render } from "./DotStats.vue?vue&type=template&id=53969d2c&scoped=true&lang=pug"
import script from "./DotStats.vue?vue&type=script&lang=js"
export * from "./DotStats.vue?vue&type=script&lang=js"

import "./DotStats.vue?vue&type=style&index=0&id=53969d2c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53969d2c"]])

export default __exports__